const isDebuggableEnv =
  process.env.NEXT_PUBLIC_TARGET_ENV === 'dev' || process.env.NEXT_PUBLIC_TARGET_ENV === 'qa'

/**
 * 디버깅용으로 원하는 환경에서 protobuf 로그를 확인할 수 있도록 콘솔 출력
 * console.log 호출 후 기존 메소드 호출
 */
export const wrapObjectMethodsWithLogging = <T extends Record<string, any>>(obj: T): T => {
  const wrappedObject = { ...obj }

  Object.keys(obj).forEach(key => {
    const value = obj[key]

    Object.keys(value).forEach(methodName => {
      const method = value[methodName]
      if (typeof method === 'function') {
        wrappedObject[key][methodName] = (...args: any[]) => {
          if (isDebuggableEnv) {
            console.log(`[protobuf] ${key} ${methodName}\n`, ...args)
          }
          return method.apply(null, args)
        }
      }
    })
  })

  return wrappedObject
}
